import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PostPage from '../../../app/containers/post-page';
import NoPostFound from '../no-post-found';
import { getLastPostSlug } from '../../selectors/last-post-slug-selectors';
import { fetchLastPost } from '../../actions/fetch-last-post';

class LastPostPage extends Component {
  static fetchData = ({ store }) => store.dispatch(fetchLastPost());

  componentDidMount() {
    if (!this.props.postSlug) {
      this.props.fetchLastPost();
    }
  }

  render() {
    const { postSlug } = this.props;
    return postSlug ? <PostPage params={{ postSlug }} /> : <NoPostFound />;
  }
}

LastPostPage.propTypes = {
  postSlug: PropTypes.string,
  fetchLastPost: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  postSlug: getLastPostSlug(state),
});

const mapDispatchToProps = {
  fetchLastPost,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LastPostPage);
